module.exports = __webpack_public_path__ + "static/media/81.5463f01a.jpg";